import { cva } from 'class-variance-authority';

export const iconVariants = cva('', {
  variants: {
    size: {
      xs: 'size-lg',
      sm: 'size-xl',
      md: 'size-2xl',
      lg: 'size-3xl',
      xl: 'size-4xl',
    },
  },
});
